module.exports = __webpack_public_path__ + "static/media/bg1.735f9ee7.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/activity_130/image/bg1.png
// module id = 375
// module chunks = 0